import React, { useId } from 'react';
import { createPortal } from 'react-dom';

const AccessibleLink = ({
  component: Component,
  description,
  children,
  ...props
}) => {
  const generatedId = useId();
  const descriptionId = description
    ? `link-description-${generatedId.replace(/:/g, '')}`
    : undefined;

  return (
    <>
      <Component
        aria-description={description}
        aria-describedby={descriptionId}
        {...props}
      >
        {children}
      </Component>
      {description && typeof document !== 'undefined'
        ? createPortal(
            <span id={descriptionId} hidden>
              {description}
            </span>,
            document.body
          )
        : null}
    </>
  );
};

export default AccessibleLink;
